import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_DAILY_PUSHES_REPORTS,
    FETCH_DAILY_PUSHES_REPORTS_FETCHING,
    FETCH_DAILY_PUSHES_REPORTS_SUCCESS,
    FETCH_DAILY_PUSHES_REPORTS_FAIL,
    FETCH_WEEKLY_PUSHES_REPORTS,
    FETCH_WEEKLY_PUSHES_REPORTS_FETCHING,
    FETCH_WEEKLY_PUSHES_REPORTS_SUCCESS,
    FETCH_WEEKLY_PUSHES_REPORTS_FAIL,
    FETCH_MONTHLY_PUSHES_REPORTS,
    FETCH_MONTHLY_PUSHES_REPORTS_FETCHING,
    FETCH_MONTHLY_PUSHES_REPORTS_SUCCESS,
    FETCH_MONTHLY_PUSHES_REPORTS_FAIL
} from '../actions/pushesActions';
import DateFormatter from '../backbone/utils/date/DateFormatter';

//Workers
export function* fetchDailyPushesSaga(action) {
    try {
        yield put({
            type: FETCH_DAILY_PUSHES_REPORTS_FETCHING
        });

        const { startDate, endDate, isLast7Days } = action.payload;
        const currentDate = DateFormatter.formatISODate(new Date());
        const response = yield call(
            gcApi.get,
            `/usersummary-service/stats/daily/${startDate}/${endDate}?statsType=PUSHES&currentDate=${currentDate}`
        );
        yield put({
            type: FETCH_DAILY_PUSHES_REPORTS_SUCCESS,
            dailyPushes: response.data,
            isLast7Days
        });
    } catch (e) {
        yield put({
            type: FETCH_DAILY_PUSHES_REPORTS_FAIL,
            dailyPushes: null
        });
    }
}

export function* fetchWeeklyPushesSaga(action) {
    try {
        yield put({
            type: FETCH_WEEKLY_PUSHES_REPORTS_FETCHING
        });

        const { endDate, numWeeks } = action.payload;
        const response = yield call(gcApi.get, `/usersummary-service/stats/pushes/weekly/${endDate}/${numWeeks}`);

        yield put({
            type: FETCH_WEEKLY_PUSHES_REPORTS_SUCCESS,
            weeklyPushes: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_WEEKLY_PUSHES_REPORTS_FAIL,
            weeklyPushes: null
        });
    }
}

export function* fetchMonthlyPushesSaga(action) {
    try {
        yield put({
            type: FETCH_MONTHLY_PUSHES_REPORTS_FETCHING
        });

        const { endDate, numMonths } = action.payload;
        const response = yield call(gcApi.get, `/usersummary-service/stats/pushes/monthly/${endDate}/${numMonths}`);

        yield put({
            type: FETCH_MONTHLY_PUSHES_REPORTS_SUCCESS,
            monthlyPushes: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MONTHLY_PUSHES_REPORTS_FAIL,
            monthlyPushes: null
        });
    }
}

//Watcher
export const pushesReportsSagas = [
    takeEvery(FETCH_DAILY_PUSHES_REPORTS, fetchDailyPushesSaga),
    takeEvery(FETCH_WEEKLY_PUSHES_REPORTS, fetchWeeklyPushesSaga),
    takeEvery(FETCH_MONTHLY_PUSHES_REPORTS, fetchMonthlyPushesSaga)
];
